import { useEffect } from "react";
import { useNavigate } from "react-router";

function App() {
  let navigate = useNavigate();
  useEffect(() => {
    navigate("/chat");
  }, []);
  return null;
}

export default App;
